import { useEffect, useRef, useState } from 'react';
import * as S from './ScoreInfo.styles';
import { notificationController } from '@app/controllers/notificationController';
import { IPracticeScore, practiceScore } from '@app/api/academic.api';
import { WordItem } from '@app/interfaces/interfaces';
import { useSelector } from 'react-redux';
import { RootState } from '@app/store/store';

interface ScoreInfoProps {
  answer: string;
  questionId: string;
  onLoaded?: () => void;
  setWords?: (words: WordItem[]) => void;
}

export const ScoreInfo: React.FC<ScoreInfoProps> = ({ answer, questionId, onLoaded, setWords }) => {
  const { timePractice } = useSelector((state: RootState) => state.exam);
  const [scoreInfo, setScoreInfo] = useState<{ score: number; total: number } | null>(null);
  const isCalled = useRef(false);

  useEffect(() => {
    if (isCalled.current) return;

    isCalled.current = true;
    const fetchPracticeScore = async () => {
      try {
        const formData = new FormData();
        formData.append('questionId', questionId);
        formData.append('answer', answer);
        formData.append('time', timePractice.toString());
        const res: IPracticeScore = await practiceScore(formData);
        setScoreInfo({ score: res.score.total, total: res.total });
        onLoaded?.();
        setWords?.(res.words || []);
      } catch (error) {
        console.error(error);
        notificationController.error({ message: 'Xảy ra lỗi. Vui lòng thử lại sau' });
      }
    };

    fetchPracticeScore();
  }, [answer, questionId, onLoaded]);

  return scoreInfo ? (
    <S.BoxScore>
      Score Info {scoreInfo.score}/{scoreInfo.total}
    </S.BoxScore>
  ) : null;
};
